import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, assetUrl, errorMessage } from "@/lib/api";

export const LogoUploader = ({ logoUrl, companyName, onUploaded }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/settings/logo", form);
      onUploaded(data.logo_url);
      toast.success("Logo updated");
    } catch (err) { toast.error(errorMessage(err)); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-4">
      {logoUrl ? <img src={assetUrl(logoUrl)} alt="Logo" className="h-16 w-16 rounded-xl border bg-card object-cover" data-testid="settings-logo-preview" />
        : <span className="flex h-16 w-16 items-center justify-center rounded-xl bg-[color:var(--brand)] text-xl font-extrabold text-white" data-testid="settings-logo-preview">
            {companyName.split(" ").slice(0, 2).map((w) => w[0]).join("")}
          </span>}
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={upload} data-testid="settings-logo-input" />
      <button type="button" onClick={() => ref.current.click()} disabled={busy} data-testid="settings-logo-upload-button"
        className="flex h-12 items-center gap-2 rounded-xl border-2 border-border bg-card px-4 font-semibold text-foreground active:scale-[0.98] transition-transform disabled:opacity-50">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} {logoUrl ? "Change logo" : "Upload logo"}
      </button>
    </div>
  );
};
